// extracted by mini-css-extract-plugin
export default {"formTemplateTripNextContainer":"CreateUpdateTrip_formTemplateTripNextContainer__JyrG+","createUpdateTripLoading":"CreateUpdateTrip_createUpdateTripLoading__XSBFe"};